import { LoginForm } from 'components/elements/forms/login-form/login-form'
import { Header } from 'components/layout/header'
import { Layout } from 'components/layout/layout'
import './_login-page.scss'
import { Cta } from 'components/blocks/cta/cta'

interface LoginPageProps {
  layout: React.ComponentProps<typeof Layout>
  header: React.ComponentProps<typeof Header>
  loginForm: React.ComponentProps<typeof LoginForm>
  certificatesLogin?: React.ComponentProps<typeof Cta>
}

export const LoginPage = ({ layout, header, loginForm, certificatesLogin }: LoginPageProps) => (
  <Layout {...layout} theme={layout.theme ?? { color: 'blue' }} className='login-page'>
    {certificatesLogin && <Cta {...certificatesLogin} />}
    {header && <Header {...header} />}
    <LoginForm {...loginForm} />
  </Layout>
)
